import { z } from 'zod';
import type { TaxonomyCampaign } from '../model/types';

export const taxonomyCampaignSchema: z.ZodType<TaxonomyCampaign> = z.looseObject({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  workspaceId: z.string(),
  createdBy: z.string().nullable(),
  updatedBy: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const taxonomyCampaignListSchema = z.array(taxonomyCampaignSchema);
